'use client';

import { c as _c } from "react/compiler-runtime";
import * as React from 'react';
import { IconTooltip } from '@components/icon-tooltip';
import { IconNames } from '@components/icon';
import { formatWholeDollarAmount } from '@utils/money';
export const SAVINGS_TOOLTIP_COPY = '💰 Direct booking prices, no markup.';
interface SavingsBannerProps {
  savingsAmountCents: number;
}
const SavingsBanner: React.FC<SavingsBannerProps> = t0 => {
  const $ = _c(8);
  const {
    savingsAmountCents
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <div className="flex items-center justify-center text-[16px]">📣</div>;
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] !== savingsAmountCents) {
    t2 = formatWholeDollarAmount(savingsAmountCents);
    $[1] = savingsAmountCents;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== t2) {
    t3 = <div className="flex-1 flex items-center justify-center"><span className="text-[14px] font-light text-center text-gray-dark">You'll save{" "}<span className="font-bold text-primary-main">{t2}</span>{" "}by booking with Savvy</span></div>;
    $[3] = t2;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <div className="flex items-center justify-center mt-0.5"><IconTooltip icon={IconNames.QUESTION_CIRCLE} placement="top">{SAVINGS_TOOLTIP_COPY}</IconTooltip></div>;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  let t5;
  if ($[6] !== t3) {
    t5 = <div className="flex items-center bg-secondary-xlight p-2 mb-2"><div className="flex items-center justify-between w-full space-x-1 px-2">{t1}{t3}{t4}</div></div>;
    $[6] = t3;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  return t5;
};
export default SavingsBanner;